import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IEntityAddressModel } from '@apps-common/types/management/entity-address'

export const getAddress = async (addressId: string): Promise<IEntityAddressModel> =>
  axios.get(`/management/address/getaddress?addressId=${addressId}`).then((res) => res.data?.data)

type QueryFnType = typeof getAddress

type Props = {
  config?: QueryConfig<QueryFnType>
  addressId: string
}

export const useManagementGetAddress = ({ config, addressId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getAddress', addressId],
    queryFn: () => getAddress(addressId)
  })
